module.exports = __webpack_public_path__ + "media/images/pc_search_ban-48613dcf45975954225b90bad338c4ca.png";